
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { addressInfoType, contactInfoType, nameInfoType } from "@/types/Application/CommonInformation";
import { getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { lawyerInformationInfoDataInfoType, noticeLawyerChildDataInfoType, childInformationNlcInfoDataInfoType } from '@/types/Application/LawyerChild';

@Component({
    components:{
        UnderlineForm,
        CheckBox       
    }
})
export default class Form40Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    

    dataReady = false;
    existingFileNumber = '';
    acknowledgeService = false;
   
    lawyerInformation = {} as lawyerInformationInfoDataInfoType;  
    childDetails: childInformationNlcInfoDataInfoType[] = [{name: '', dob: ''}];    
   
    listOfIssues = [];    
    otherIssue = '';
    firstOtherParty = '';
    otherPartiesList = [];    

    childTableFields = [
        {key:"name",  label:"Child’s full name",       tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:55%;"},
        {key:"dob",   label:"Child’s Date of Birth",   tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:35%;"}
    ];
   
    mounted(){
        this.dataReady = false;
        //console.log(this.result)
        this.extractInfo();
        this.dataReady = true;        
    }
   
    public extractInfo(){
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        this.acknowledgeService = this.result.otherPartyNLCConfirmationSurvey?.confirmation == 'Confirmed';
        this.getNoticeLawyerChildInfo();  
    } 

    public getNoticeLawyerChildInfo(){  
        
        this.lawyerInformation = {} as lawyerInformationInfoDataInfoType;          
        this.firstOtherParty = '';
        this.otherPartiesList = []; 
        this.childDetails = [{name: '', dob: ''}];
        this.listOfIssues = [];  
        this.otherIssue = ''; 

        if(this.result?.noticeLawyerChildSurvey){

            let noticeLawyerChild = {} as noticeLawyerChildDataInfoType;
            noticeLawyerChild = this.result.noticeLawyerChildSurvey;    

            this.getLawyerInformationResults(noticeLawyerChild);

            const otherParties = [];
            for (const otherParty of noticeLawyerChild.OtherPartyInfoNlc){
                otherParties.push(Vue.filter('getFullName')(otherParty.name))
            }           

            this.firstOtherParty = otherParties[0];
            this.otherPartiesList = otherParties.length>1?otherParties.slice(1):[];

            const childrenInfo = [];

            for (const child of noticeLawyerChild.ChildInfoNlc){
                const childInfo = {} as childInformationNlcInfoDataInfoType;
                childInfo.dob = child.dateOfBirth?Vue.filter('beautify-date')(child.dateOfBirth):'';
                childInfo.name = child.name?Vue.filter('getFullName')(child.name):'';
                childrenInfo.push(childInfo);
            }

            if (childrenInfo.length>0){
                this.childDetails = childrenInfo;
            }

            this.listOfIssues = noticeLawyerChild.IssuesList?noticeLawyerChild.IssuesList:[];
            if (this.listOfIssues.includes("other")){
                this.otherIssue = noticeLawyerChild.IssuesListComment?noticeLawyerChild.IssuesListComment:'';
            }            
        }             
    }

    public getLawyerInformationResults(noticeLawyerChild: noticeLawyerChildDataInfoType) {               

        this.lawyerInformation = {
            firmName: noticeLawyerChild.FirmName?noticeLawyerChild.FirmName:'',
            lawyerName: noticeLawyerChild.ApplicantName?noticeLawyerChild.ApplicantName:{} as nameInfoType,
            address: noticeLawyerChild.LawyerAddressNlc?noticeLawyerChild.LawyerAddressNlc:{} as addressInfoType,
            contact: noticeLawyerChild.LawyerContact?noticeLawyerChild.LawyerContact:{} as contactInfoType
        }          
    }
 
}
